export const JOB_STATUS_COLORS = {
  Invited: 'yellow',
  Upcoming: 'blue',
  Accepted: 'blue',
  Past: 'blue',
  Completed: 'teal',
};

export const getJobStatusColor = (status) => JOB_STATUS_COLORS[status] || 'red';
